import React, { memo, useCallback } from 'react';
import { Segmented } from 'antd';
import { useLanguageStore } from '../../api/store';
import { LanguageTypes } from '../../constants/LanguageTypes';
import { useTheme } from '../../../../modules/theme/ThemeProvider';
import './style.css';

interface LanguageSegmentedProps {
    className?: string;
}

const LanguageSegmented: React.FC<LanguageSegmentedProps> = ({ className = '' }) => {
    const { changeLanguage, type } = useLanguageStore();
    const { theme } = useTheme();
    const themeClass = theme === 'dark' ? 'language-segmented-dark' : '';

    const options = [
        { label: 'RU', value: LanguageTypes.ru },
        { label: 'KZ', value: LanguageTypes.kz },
    ];

    const handleChange = useCallback((newValue: string | number, e?: any) => {
        e?.stopPropagation();
        changeLanguage(newValue as LanguageTypes);
    }, [changeLanguage]);

    const handleClick = useCallback((e: React.MouseEvent) => {
        e.stopPropagation();
    }, []);

    return (
        <div className={`language-segmented ${themeClass} ${className}`} onClick={handleClick}>
            <Segmented
                value={type}
                onChange={handleChange}
                options={options}
                className="language-segmented-control"
                size="middle"
                onClick={handleClick}
            />
        </div>
    );
};

export default memo(LanguageSegmented); 